<template>
  <h4>You are in home.</h4>
</template>


<script>
// import moment from 'moment'

export default {
  data () {
    return {
      justLogin: localStorage.getItem('justLogin')
    }
  },
  mounted () {
    if (this.justLogin === 'yes') {
      this.$vs.loading()
      this.checkUser()
    }
  },
  methods: {
    checkUser () {
      this.$http.get('/auth/user')
        .then(({ data }) => {
          if (data.success) {
            this.$swal({
              title:`Welcome ${this.$store.state.AppActiveUser.displayName} !`,
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            })
            this.$vs.loading.close()
            localStorage.setItem('justLogin', 'no')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Login Failed',
              text: data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              timer: 1500
            })
          }
        })
        .catch(e => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Failed to check user',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    }
  }
}
</script>
